<div
  class="app-download-banner"
  [class.horizontal]="variant === 'horizontal'"
  [class.sidebar]="variant === 'sidebar'">

  <button *ngIf="dismissible" class="dismiss-btn" (click)="dismiss()">
    <ng-icon name="heroXMark"></ng-icon>
  </button>

  <div class="phone-mockups">
    <img class="phone-left" src="assets/images/app-download/phone-left.png" alt="" />
    <img class="phone-right" src="assets/images/app-download/phone-right.png" alt="" />
  </div>

  <div class="banner-content">
    <p class="banner-text">{{ 'APP_DOWNLOAD.TITLE' | translate }}</p>

    <div *ngIf="isDesktop" class="qr-wrapper">
      <img src="assets/images/app-download/qr-code.png" alt="Scan to download" class="qr-code" />
      <img src="assets/images/rosie-icon.svg" alt="" class="qr-logo-overlay" />
    </div>
    <div *ngIf="!isDesktop" class="badge-row">
      <a [href]="appStoreUrl" target="_blank" rel="noopener" class="store-badge">
        <img src="assets/images/app-download/app-store-badge.svg" alt="{{ 'APP_DOWNLOAD.APP_STORE' | translate }}" />
      </a>
      <a [href]="playStoreUrl" target="_blank" rel="noopener" class="store-badge">
        <img class="google-play-badge" src="assets/images/app-download/google-play-badge.svg" alt="{{ 'APP_DOWNLOAD.GOOGLE_PLAY' | translate }}" />
      </a>
    </div>
  </div>
</div>
